import React, { useState, useEffect } from "react";
import axios from "axios";

import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid
} from "recharts";

import "./MnthlySlsDtls.css";

export default function MntlySlsDtls({ setMntlyRecSls, defaultRange = null, setDlySls = null }) {

  const [data, setData] = useState([]);
  const [range, setRange] = useState( defaultRange||"month");
  const [metric, setMetric] = useState("sales");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [loading, setLoading] = useState(false);


  const fetchSalesData = async (selectedRange = range) => {

    const userData =
      JSON.parse(
        sessionStorage.getItem("userData")
      );

    const userId =
      userData.id;

    const machineId =
      userData.selectedMachineIds[0];


    try {

      setLoading(true);

      const res =
        await axios.get(
          "/api/sales-summary-grapgh",
          {
            params: {
              userId,
              machineId,
              range:
                selectedRange,
              metric,
              fromDate,
              toDate
            },
            withCredentials:
              true
          }
        );

      setData( res.data);
      // console.log(res.data, "this is bara data")
    }

    catch (err) {
      console.log( err );
    }

    finally {
      setLoading(false);
    }

  };

  const closeDtls = () =>{
    if(setMntlyRecSls){
      setMntlyRecSls(false);
    }else if(setDlySls){
      setDlySls(false);

    }
  }
  useEffect(() => {
    fetchSalesData(range);
  },[ range, metric]);

  return (

    <div className="fl-pg-cont">


      {/* Header */}

      <div className="hdng-prnt">

        <div className="pg-tp-hdng">

          <div>

            Best Sellers ({range}) by:

            <select
              value={metric}
              onChange={e =>
                setMetric(
                  e.target.value
                )
              } >

              <option value="sales">
                Sell Count
              </option>


              <option value="revenue">
                Revenue
              </option>


              <option value="profit">
                Profit
              </option>

            </select>

          </div>

          {/* Custom Dates */}
          <div className="cstm-dte-grph">
            <input
              type="date"
              value={fromDate}
              onChange={e =>
                setFromDate(
                  e.target.value
                )
              }
            />
            <input
              type="date"
              value={toDate}
              onChange={e =>
                setToDate(
                  e.target.value
                )
              }
            />
            <button
              onClick={() => { setRange("custom");
                fetchSalesData("custom");
              }}
            > Apply
            </button>
          </div>

          <button
            onClick={closeDtls}
          >

            X

          </button>
        </div>
      </div>
      {/* Filters */}
      <div className="hdng-prnt">
        <div className="pg-tp-hdng serch-btn-cont">
          <div className="srch-btns">
            <button
              className={`srch-cls-mpt ${ range === "day" ? "srch-btn-active-cls" : ""}`}
              onClick={() =>
                setRange("day")}
            > Day
            </button>
            <button
              className={`srch-cls-mpt ${
                range === "week"
                  ? "srch-btn-active-cls"
                  : ""
              }`}
              onClick={() =>
                setRange(
                  "week"
                )
              }
            > Week
            </button>

            <button
              className={`srch-cls-mpt ${
                range === "month"
                  ? "srch-btn-active-cls"
                  : ""
              }`}
              onClick={() => setRange( "month" ) }>
              Month
            </button>

            <button
              className={`srch-cls-mpt ${
                range === "6months"
                  ? "srch-btn-active-cls"
                  : ""
              }`}
              onClick={() =>
                setRange("6months")}>
              6 Months
            </button>
            <button
              className={`srch-cls-mpt ${
                range === "year"
                  ? "srch-btn-active-cls"
                  : ""
              }`}
              onClick={() =>setRange("year")
              }
            > Year </button>
          </div>
        </div>
      </div>
      {/* Chart */}
      <div
        style={{
          width:
            "100%",
          height:
            "92%"
        }}
      >
        {
          loading ? (
            <div> Loading... </div>
          ):(
            <ResponsiveContainer>
              <BarChart
                data={data}
              >
                <CartesianGrid
                  strokeDasharray="3 3"
                />
                <XAxis
                  dataKey="name"
                  tickFormatter={
                    value => value.startsWith( "Empty" ) ? "" : value }
                />
                <YAxis />
                <Tooltip />
                <Bar
                  dataKey={ metric }
                  fill="#EF7C32"
                  radius={[8,8,0,0]}
                />


              </BarChart>


            </ResponsiveContainer>

          )

        }


      </div>


    </div>

  );

}
